import { FC, useMemo } from 'react';
import { InfiniteList } from 'melp-design/components';
import { newsCommentsFiltersSchema, useInfiniteNewsComments } from 'store/news';
import { CommentContainer } from 'containers/comments';

interface Props {
  newId: string;
}

export const CommentsFeed: FC<Props> = ({ newId }) => {
  const { data, fetchNextPage, hasNextPage, isLoading } =
    useInfiniteNewsComments({
      ...newsCommentsFiltersSchema.parse({}),
      news: [newId],
    });

  const comments = useMemo(() => {
    return data
      ? {
          items: (data.pages.map(({ items }) => items) ?? []).flat(),
          total: data.pages[0]?.total,
        }
      : null;
  }, [data]);

  return (
    <InfiniteList
      data={comments?.items}
      renderItem={(comment) => <CommentContainer comment={comment} />}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isLoading={isLoading}
    />
  );
};
